import React from 'react';

function FeedbackMoneyBillStackIcon() {
  return (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none">
      <title>Ilustração de pilha de dinheiro</title>
      <path d="M2.84001 9.51988H3.80001V11.4399H2.84001V9.51988Z" fill="#707070" />
      <path d="M3.80001 2.79988H2.84001V4.71988H3.80001V2.79988Z" fill="#707070" />
      <path d="M18.2 2.79988H19.16V4.71988H18.2V2.79988Z" fill="#707070" />
      <path d="M19.16 9.51988H18.2V11.4399H19.16V9.51988Z" fill="#707070" />
      <path d="M11 2.79988C13.5839 2.79988 15.32 4.53602 15.32 7.11988C15.32 9.70375 13.5839 11.4399 11 11.4399C8.41617 11.4399 6.68001 9.70375 6.68001 7.11988C6.68001 4.53602 8.41617 2.79988 11 2.79988ZM14.36 7.11988C14.36 5.07895 13.041 3.75988 11 3.75988C8.95905 3.75988 7.64001 5.07895 7.64001 7.11988C7.64001 9.16082 8.95905 10.4799 11 10.4799C13.041 10.4799 14.36 9.16082 14.36 7.11988Z" fill="#707070" />
      <path d="M0.920013 0.879883V19.1199H21.08V0.879883H0.920013ZM20.12 14.3199H1.88001V13.3599H20.12V14.3199ZM1.88001 16.2399V15.2799H20.12V16.2399H1.88001ZM20.12 18.1599H1.88001V17.1999H20.12V18.1599ZM20.12 1.83988V12.3999H1.88001V1.83988H20.12Z" fill="#707070" />
    </svg>
  );
}

export default FeedbackMoneyBillStackIcon;
